import React, { FC } from "react";
import MaterialTypography from "@mui/material/Typography";

import { IProps } from "./types";

export const Typography: FC<IProps> = props => (
  <MaterialTypography {...props} />
);
